import { DieEventValues } from "@/enums";
import type { CustomUrlMap, DieType, Manifest, Trigger } from "@/types";

export const fallbackCollisionSounds = [
  "sounds/collision-1.wav",
  "sounds/collision-2.wav",
  "sounds/collision-3.wav",
];

export const getSoundPaths = (sounds?: Manifest["resources"]["sounds"]) =>
  Object.values(sounds ?? fallbackCollisionSounds);

export const shouldSkipCollisionSound = (event?: DieEventValues) =>
  event === DieEventValues.rollComplete ||
  event === DieEventValues.minRoll ||
  event === DieEventValues.maxRoll ||
  event === DieEventValues.dieRemoved;

export const getCollisionSoundPaths = (soundPaths: string[]) =>
  soundPaths.filter((sound) => sound.toLowerCase().includes("collision"));

export const getRandomSoundPath = (soundPaths: string[]) => {
  if (!soundPaths.length) return;

  return soundPaths[Math.floor(Math.random() * soundPaths.length)];
};

export const getRandomCollisionSoundPath = (soundPaths: string[]) =>
  getRandomSoundPath(getCollisionSoundPaths(soundPaths));

export const getSoundUrl = ({
  customUrlMap,
  hasManifestSounds,
  mediaUrl,
  setCodename,
  soundPath,
}: {
  customUrlMap?: CustomUrlMap;
  hasManifestSounds: boolean;
  mediaUrl: string;
  setCodename: string;
  soundPath: string;
}) =>
  customUrlMap
    ? customUrlMap[soundPath]
    : `${mediaUrl}/dice${hasManifestSounds ? `/bundles/${setCodename}` : ""}/${soundPath}`;

export const getTriggeredSoundPath = ({
  dieType,
  event,
  manifest,
  soundPaths,
}: {
  dieType: DieType;
  event?: string;
  manifest: Manifest;
  soundPaths: string[];
}) => {
  if (!event) return;

  const sounds = manifest[dieType].sounds?.map((trigger) => {
    if (Array.isArray(trigger)) {
      return trigger[Math.floor(Math.random() * trigger.length)];
    }

    return trigger;
  }) as Trigger[] | undefined;
  const soundKey = sounds?.find(
    ({ triggerStart }) => triggerStart === event,
  )?.definition;

  if (!soundKey) return;

  const targetSound = manifest.resources.sounds[soundKey];

  return soundPaths.find((sound) => sound === targetSound);
};
